/**
 * Requests to external modules (e.g. BI Alert) must not trigger main-app auth recovery flows
 * such as redirect to /forbidden or session refresh retry on 401.
 */
export function isBiAlertRequest(url: string, biAlertUrl: string): boolean {
    if (!biAlertUrl) {
        return false;
    }

    return url.startsWith(biAlertUrl);
}

export function isExternalModuleRequest(url: string, biAlertUrl: string): boolean {
    return isBiAlertRequest(url, biAlertUrl);
}
